var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ejs-tab',{ref:"userTabs",attrs:{"id":"element","selectedItem":_vm.selectedItem}},[_c('e-tabitems',[_c('e-tabitem',{attrs:{"header":_vm.headerText1,"content":_vm.userTemplate}}),_c('e-tabitem',{attrs:{"header":_vm.headerText2,"content":_vm.groupsAndPermissionsTemplate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }